module.exports = __webpack_public_path__ + "resource/img/PaleRed.14de41ce.png";